import { render, staticRenderFns } from "./AddItemToSectionModal.vue?vue&type=template&id=ecedae7c&"
import script from "./AddItemToSectionModal.vue?vue&type=script&lang=js&"
export * from "./AddItemToSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports